var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-xl-12 col-lg-12 col-sm-12 col-md-12 mt-3"},[_c('generalForm',{attrs:{"typeForm":"address","variableData":_vm.variableDataComponent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }